<template>
  <div>
    <!-- layout -->
    <BasicInfo
      v-if="!isNeedPreventModalScroll"
      :data="data"
      :isEditMode="isEditMode"
      :isShowSend="isShowSend"
      @clickImg="clickImg"
      @clickSend="clickSend"
      @clickAnswer="clickAnswer"
      @clickReceive="clickReceive"
      @clickAnswerRate="clickAnswerRate"
      @clickPv="clickPv"
      @clickEdit="m='edit-user'"
    ></BasicInfo>
    <input
      id="user-upload-avatar"
      class="invisible" type="file" accept="*/*"
      @change="commitImg">

    <div style="padding-top:10px"></div>
    <TextModule
      v-if="!isNeedPreventModalScroll"
      :data="descData"
      :isEditMode="isEditMode"
      @click="m='edit-user-desc'"
    >
      <pre class="pre">{{data.card.profile}}</pre>
    </TextModule>
    <div v-if="isMobile" class="md-line"></div>

    <div v-if="!isNeedPreventModalScroll" v-for="(row, i) in data.user_module" :key="i" class="user-module">
      <div v-if="isMobile && i!==0" class="md-line"></div>
      <TextModule v-if="row.type==='md-text'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="edit(row, i)"></TextModule>
      <ListModule v-if="row.type==='md-list'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="edit(row, i)"></ListModule>
      <CaseModule v-if="row.type==='md-case'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="edit(row, i)" @more="more(row, i)"></CaseModule>
      <TalkModule v-if="row.type==='md-talk'" :isEditMode="isEditMode" :config="config" :data="row" :index="i" @click="edit(row, i)"></TalkModule>
    </div>
    <UserSettingModule
      v-if="!isNeedPreventModalScroll && isEditMode"
      :isEditMode="isEditMode"
      :data="data"
      @update:data="updateUser"
    ></UserSettingModule>

    <EditUserModal v-if="m==='edit-user' && !isMobile" :data="data" @close="closeModal" @commit="commitUser"></EditUserModal>
    <EditUserPage v-if="m==='edit-user' && isMobile"
      :data="data"
      @close="closeModal"
      @back="closeModal"
      @commit="commitUser"
    ></EditUserPage>
    <NutsbpLoginModal v-if="m === 'nutsbp-login'" @close="closeModal" @commit="commitNutsbpLogin" :error="error"></NutsbpLoginModal>
    <SendBpModal v-if="m==='sendbp'" @close="closeModal" @create="createBp" :data="data"></SendBpModal>
    <MessageModal v-if="m==='download-mobile'" @close="closeModal">
      <div class="download-mobile">
        <div class="download-mobile-body">
          <div class="download-mobile-body-center">
            <div>你好，手机Web版暂不支持投递</div>
            <div>
              <span>你可以到PC版投递：</span><a @click="clickToPcVersion">www.nutsbp.com</a>
            </div>
            <div>或到应用商店下载疯狂BP</div>
          </div>
        </div>
        <div v-if="isShowDownloadButton" class="download-mobile-footer">
          <BaseButton2 class="download-mobile-footer-button" @click="clickDownload">前往商店下载</BaseButton2>
        </div>
        <div v-if="!isShowDownloadButton" class="download-mobile-footer">
          <BaseButton2 class="download-mobile-footer-button" :type="2" @click="closeModal">确定</BaseButton2>
        </div>
      </div>
    </MessageModal>
    <!-- <MessageModal v-if="m==='share-me'" @close="closeModal">
      <div class="download-mobile">
        <div class="download-mobile-body">
          <div class="download-mobile-body-center">
            <div>点击分享，传播个人品牌，提高个人影响力</div>
          </div>
        </div>
        <div class="download-mobile-footer">
          <BaseButton1 class="download-mobile-footer-button" @click="clickShareMp">分享</BaseButton1>
        </div>
      </div>
    </MessageModal> -->
    <WeixinShareCover v-if="m==='share-me'" text="吸引更多优秀项目投递，传播个人品牌" @click="closeModal"></WeixinShareCover>

    <EditUserDescModal v-if="m==='edit-user-desc' && !isMobile" :data="data" @close="closeModal" @commit="commitUserDesc"></EditUserDescModal>
    <EditUserDescPage v-if="m==='edit-user-desc' && isMobile" :data="data"
      @close="closeModal"
      @back="closeModal"
      @commit="commitUserDesc"></EditUserDescPage>

    <EditTextModal v-if="m==='md-text'" :data="editData" @close="closeEdit" @commit="commitEdit" :config="config"></EditTextModal>

    <EditListModal v-if="m==='md-list' && !isMobile" :data="editData" @close="closeEdit" @commit="commitEdit" :config="config"></EditListModal>
    <EditListPage  v-if="m==='md-list' && isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @back="closeEdit"
      @commit="commitEdit"
      ></EditListPage>

    <EditCaseModal v-if="m==='md-case' && !isMobile" :data="editData" @close="closeEdit" @commit="commitEdit" :config="config"></EditCaseModal>
    <EditCasePage  v-if="m==='md-case' && isMobile" :data="editData" :config="config"
      @close="closeEdit"
      @back="closeEdit"
      @commit="commitEdit"
      ></EditCasePage>

    <EditTalkModal v-if="m==='md-talk'" :data="editData" @close="closeEdit" @commit="commitEdit" :config="config"></EditTalkModal>
  </div>
</template>

<script>
import _ from 'lodash'
import env from '@/env.js'
import Mem from '@/Mem.js'
import Store from '@/Store.js'

import {
  nutsbpV2,
  dcV2Graphql
} from '@/api'

import BasicInfo from './BasicInfo.vue'

import {
  UserSettingModule,
  TextModule,
  ListModule,
  CaseModule,
  TalkModule
} from '../module'

import {
  EditUserModal,
  EditUserDescModal,
  EditTextModal,
  EditListModal,
  EditCaseModal,
  EditTalkModal,
  SendBpModal,
  NutsbpLoginModal,
  MessageModal,
  EditUserPage,
  EditUserDescPage,
  EditListPage,
  EditCasePage,
  BaseButton1,
  BaseButton2,
  WeixinShareCover
} from '@/components'

export default {
  components: {
    BasicInfo,
    UserSettingModule,
    TextModule,
    ListModule,
    CaseModule,
    TalkModule,
    EditUserModal,
    EditUserDescModal,
    EditTextModal,
    EditListModal,
    EditCaseModal,
    EditTalkModal,
    SendBpModal,
    NutsbpLoginModal,
    MessageModal,
    EditUserPage,
    EditUserDescPage,
    EditListPage,
    EditCasePage,
    BaseButton1,
    BaseButton2,
    WeixinShareCover
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    isNutsbpLogin: {
      type: Boolean,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isShowSend: {
      type: Boolean,
      default: true
    },
    isMyHome: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      m: null,
      editData: null,
      editIndex: -1,
      isLocked: false,
      error: null
    }
  },
  computed: {
    userBasicMdData () {
      return {
        type: 'md-text',
        name: this.data.card.title,
        value: this.data.card.profile
      }
    },
    isMobile () {
      return env.isMobile
    },
    descData () {
      return {
        name: '个人简介',
        icon: 'icon-pr_phone_icon_profiles_small',
        icon_body: env.isMobile ? null : 'profiles_big'
      }
    },
    isNeedPreventModalScroll () {
      if (!this.isMobile) { // 非手機都不用
        return false
      }
      if (
        this.m !== null &&
        this.m !== 'download-mobile' &&
        this.m !== 'share-me'
      ) {
        return true
      }
      return false
    },
    isShowShareMe () {
      if (this.$route.query.hasOwnProperty('share-me')) {
        return true
      }
      return false
    },
    isShowDownloadButton () {
      if (this.$route.query.hasOwnProperty('nodl')) {
        return false
      }
      return true
    }
  },
  methods: {
    closeModal () { this.m = null },
    clickImg () {
      if (env.isMobile) {
        return
      }
      if (!this.isEditMode) {
        return
      }
      document.getElementById('user-upload-avatar').click()
    },
    clickSend () {
      if (this.isShowShareMe) {
        this.m = 'share-me'
        return
      }
      if (env.isMobile) {
        this.m = 'download-mobile'
        return
      }
      if (this.isNutsbpLogin) {
        this.m = 'sendbp'
        return
      }
      this.m = 'nutsbp-login'
    },
    clickShareMp () { this.$emit('clickShareMp') },
    clickAnswer () { console.log('clickAnswer') },
    clickReceive () { console.log('clickReceive') },
    clickAnswerRate () { console.log('clickAnswerRate') },
    clickPv () { console.log('clickPv') },
    clickToPcVersion () {
      window.open('https://www.nutsbp.com', '_blank')
    },
    clickDownload () {
      window.open('https://download.nutsbp.com', '_blank')
    },
    updateUser (data) {
      this.$emit('update:user', data)
    },
    updateMe (data) {
      this.$emit('update:me', data)
    },

    async commitImg (event) {
      let oFile = event.target.files[0]
      if (!oFile || !oFile.type) {
        throw new Error('请选择正确格式')
      }
      let mb = 10
      let iMaxFilesize = 1048576 * mb
      if (oFile.size > iMaxFilesize) {
        throw new Error(`档案尺寸超出 ${mb}MB 上限`)
      }
      await this.commitUserHeadImage(oFile)
    },
    async commitUser (input) {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        if (input.img) {
          await this.commitUserHeadImage(input.img)
        }
        let variables = {
          city: input.city,
          province: input.province,
          name: input.name,
          title: input.title
        }
        let res = await dcV2Graphql.post('', {
          query: `mutation ($city: String, $province: String, $name: String, $title: String) {
            updateUser(city: $city, province: $province, name: $name, title: $title) {
              id
            }
          }`,
          variables
        }, {
          headers: {
            'tephra-session-id': Store.get('sid')
          },
          loading: '保存中...'
        })
        let errors = _.get(res, 'data.errors')
        if (errors) {
          throw new Error(_.get(errors, '[0].msg') || 'update failed')
        }
        this.updateUser({
          province: input.province,
          city: input.city,
          card: {
            name: input.name,
            title: input.title
          }
        })
        this.closeModal()
      } catch (e) {
        console.error('commitUser e', e)
        this.error = e.message
      } finally {
        this.isLocked = false
      }
    },
    async commitUserHeadImage (oFile) {
      let formdata = new FormData()
      formdata.append('file', oFile)
      formdata.append('query', `mutation {
        updateUserHeadImage {
          id, card { head_image_url }
        }
      }`)
      let res = await dcV2Graphql.post('', formdata, {
        headers: {
          'tephra-session-id': Store.get('sid')
        },
        loading: '保存中...'
      })
      let errors = _.get(res, 'data.errors')
      if (errors) {
        throw new Error(_.get(errors, '[0].msg') || 'update failed')
      }
      let data = _.get(res, 'data.data.updateUserHeadImage')
      let head_image_url = _.get(data, 'card.head_image_url') // eslint-disable-line camelcase
      this.updateUser({
        card: { head_image_url }
      })
      if (this.isMyHome) {
        this.updateMe({
          card: { head_image_url }
        })
      }
      return data
    },
    async commitUserDesc (input) {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        await dcV2Graphql.post('', {
          query: `mutation ($profile: String) {
            updateUser(profile: $profile) { id }
          }`,
          variables: {
            profile: input.profile
          }
        }, {
          headers: {
            'tephra-session-id': Store.get('sid')
          },
          loading: '保存中...'
        })
        this.updateUser({
          card: {
            profile: input.profile
          }
        })
        this.closeModal()
      } catch (e) {
        console.error('commitUserDesc e', e)
      } finally {
        this.isLocked = false
      }
    },
    edit (row, i) {
      this.editData = row
      this.editIndex = i
      this.m = row.type
    },
    closeEdit () {
      this.closeModal()
      this.editData = null
      this.editIndex = -1
    },
    async commitEdit (input) {
      if (this.isLocked) {
        return
      }
      try {
        this.isLocked = true
        let res = null
        let type = null
        let data = null
        switch (this.editData.type) {
          case 'md-list':
            type = 'preference'
            data = {
              stage: _.get(input, '[0].value', []),
              field: _.get(input, '[1].value', []),
              amount: _.get(input, '[2].value', [0, 0])
            }
            break
          case 'md-case':
            type = 'case'
            data = input.map(row => {
              return {
                name: row.name,
                desc: row.value,
                industry: row.label,
                logo: row.logo
              }
            })
            break
          default:
            return
        }
        if (this.editData.hasOwnProperty('id')) {
          res = await dcV2Graphql.post('', {
            query: `mutation ($id: Int, $type: String, $data: JSON) {
              updateUserModule(id: $id, type: $type, data: $data) { id }
            }`,
            variables: {
              id: this.editData.id,
              type,
              data
            }
          }, {
            headers: {
              'tephra-session-id': Store.get('sid')
            },
            loading: '保存中...'
          })
        } else {
          res = await dcV2Graphql.post('', {
            query: `mutation ($type: String, $data: JSON) {
              createUserModule(type: $type, data: $data) { id }
            }`,
            variables: { type, data }
          }, {
            headers: {
              'tephra-session-id': Store.get('sid')
            },
            loading: '保存中...'
          })
          console.log('TODO update module id', _.get(res, 'data.data.createUserModule.id'))
        }
        this.$emit('update:module', this.editIndex, input)
        this.closeModal()
      } catch (e) {
        console.error('commitEdit e', e)
      } finally {
        this.isLocked = false
      }
    },
    more (row, i) { console.log('more', row, i) },
    createBp () {
      let url
      if (env.isMobile) {
        url = env.downloadUrl
      } else {
        url = `${env.editorUrlV4}/?u=${Store.get('u')}#lobby`
      }
      window.open(url, '__blank')
    },
    async commitNutsbpLogin (input) {
      try {
        this.isLocked = true
        let options = {
          account: input.username,
          password: input.password
        }
        let res = await nutsbpV2.post('/login', options)
        Mem.set('nutsbp', _.get(res, 'data.data'))
        Store.set('u', Mem.get('nutsbp.u'))
        this.$emit('update:isNutsbpLogin', true)
        this.m = 'sendbp'
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
      } finally {
        this.isLocked = false
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.md-line {
  width: 100%;
  border-top: 1px solid var(--colorGray4);
}
.download-mobile {
  & .download-mobile-body {
    position: relative;
    text-align: center;
    color: var(--colorGray0);

    @media (--mediaPc) {
      font-size: var(--textSize3);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize3Mobile);
    }
    & .download-mobile-body-center {
      @media (--mediaPc) {
        padding: 58px 0;
        margin: 0 58px;
      }
      @media (--mediaMobile) {
        padding: calc(58px / var(--scaleMobile)) 0;
        margin: 0 calc(58px / var(--scaleMobile));
      }
    }
    &::before {
      content: '';
      width: 0;
      height: 100%;
      display: inline-block;
      position: relative;
      vertical-align: middle;
    }
  }
  & .download-mobile-footer {
    text-align: center;
    @media (--mediaPc) {
      bottom: 36px;
    }
    @media (--mediaMobile) {
      bottom: calc(36px / var(--scaleMobile));
    }
    & .download-mobile-footer-button {
      @media (--mediaPc) {
        width: 100px;
        margin: 0 20px;
      }
      @media (--mediaMobile) {
        width: calc(240px / var(--scaleMobile));
        margin: 0 calc(32px / var(--scaleMobile) / 2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/user/Main.vue